"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const client_library_1 = require("@seneca/client-library");
const school_analytics_service_consts_1 = require("@seneca/school-analytics-service-consts");
const SchoolNotFoundError_1 = __importDefault(require("./errors/SchoolNotFoundError"));
const SchoolSyncExpiredError_1 = __importDefault(require("./errors/SchoolSyncExpiredError"));
const ForbiddenSchoolAccessError_1 = __importDefault(require("./errors/ForbiddenSchoolAccessError"));
const InvalidBodyFieldError_1 = __importDefault(require("./errors/InvalidBodyFieldError"));
class SchoolAnalyticsServiceClient extends client_library_1.Client {
    async createDataRequest(body) {
        const url = `${this.url}/api/schoolAnalytics/me`;
        const expectedResponses = [201, 422];
        const response = await this.requestMaker.makeRequest(url, {
            method: 'POST',
            body: JSON.stringify(body)
        }, expectedResponses);
        if (response.status === 422) {
            const { reason, pointer } = response.json;
            throw new InvalidBodyFieldError_1.default(pointer, reason);
        }
        return response.json;
    }
    async fetchMyDataRequests() {
        return this._pageMethod({
            method: this.fetchPageOfDataRequests.bind(this)
        });
    }
    async fetchPageOfDataRequests(options = {}) {
        const baseUrl = `${this.url}/api/schoolAnalytics/me`;
        const expectedResponses = [200];
        const params = this._generatePagingQueryParams(options);
        const url = params.length > 0 ? `${baseUrl}?${params.join('&')}` : baseUrl;
        const response = await this.requestMaker.makeRequest(url, {
            method: 'GET'
        }, expectedResponses);
        return response.json;
    }
    async fetchDataRequest(requestId) {
        const url = `${this.url}/api/schoolAnalytics/me/${requestId}`;
        const expectedResponses = [200];
        const response = await this.requestMaker.makeRequest(url, {
            method: 'GET'
        }, expectedResponses);
        return response.json;
    }
    async retryFailedRequest(body) {
        const url = `${this.url}/api/schoolAnalytics/retry/me`;
        const expectedResponses = [200];
        const response = await this.requestMaker.makeRequest(url, {
            method: 'POST',
            body: JSON.stringify(body)
        }, expectedResponses);
        return response.json;
    }
    /**
     * @deprecated newer `fetchSchoolStudentsReportForSchool` should be used instead of this method
     */
    async fetchSchoolStudentsReport({ startDate, endDate, yearGroups, departments }) {
        const url = `${this.url}/api/reports/students`;
        const expectedResponses = [200];
        const filters = {};
        if (yearGroups && yearGroups.length > 0) {
            filters.yearGroups = yearGroups;
        }
        if (departments && departments.length > 0) {
            filters.departments = departments;
        }
        const response = await this.requestMaker.makeRequest(url, {
            method: 'POST',
            body: JSON.stringify(Object.assign({ startDate,
                endDate }, (Object.keys(filters).length && { filters })))
        }, expectedResponses);
        return response.json;
    }
    async fetchSchoolStudentsReportForSchool({ startDate, endDate, yearGroups, departments, schoolId }) {
        const url = `${this.url}/api/schools/${schoolId}/reports/students`;
        const expectedResponses = [200, 403];
        const filters = {};
        if (yearGroups && yearGroups.length > 0) {
            filters.yearGroups = yearGroups;
        }
        if (departments && departments.length > 0) {
            filters.departments = departments;
        }
        const response = await this.requestMaker.makeRequest(url, {
            method: 'POST',
            body: JSON.stringify(Object.assign({ startDate,
                endDate }, (Object.keys(filters).length && { filters })))
        }, expectedResponses);
        if (response.status === 403) {
            throw new ForbiddenSchoolAccessError_1.default(schoolId);
        }
        return response.json;
    }
    async fetchSchoolTeachersReportForSchool({ startDate, endDate, yearGroups, departments, schoolId }) {
        const url = `${this.url}/api/schools/${schoolId}/reports/teachers`;
        const expectedResponses = [200, 403];
        const filters = {};
        if (yearGroups && yearGroups.length > 0) {
            filters.yearGroups = yearGroups;
        }
        if (departments && departments.length > 0) {
            filters.departments = departments;
        }
        const response = await this.requestMaker.makeRequest(url, {
            method: 'POST',
            body: JSON.stringify(Object.assign({ startDate,
                endDate }, (Object.keys(filters).length && { filters })))
        }, expectedResponses);
        if (response.status === 403) {
            throw new ForbiddenSchoolAccessError_1.default(schoolId);
        }
        return response.json;
    }
    /**
     * @deprecated newer `fetchSchoolTeachersReportForSchool` should be used instead of this method
     */
    async fetchSchoolTeachersReport({ startDate, endDate, yearGroups, departments }) {
        const url = `${this.url}/api/reports/teachers`;
        const expectedResponses = [200];
        const filters = {};
        if (yearGroups && yearGroups.length > 0) {
            filters.yearGroups = yearGroups;
        }
        if (departments && departments.length > 0) {
            filters.departments = departments;
        }
        const response = await this.requestMaker.makeRequest(url, {
            method: 'POST',
            body: JSON.stringify(Object.assign({ startDate,
                endDate }, (Object.keys(filters).length && { filters })))
        }, expectedResponses);
        return response.json;
    }
    async fetchActiveUsersBySchool({ from, to, schoolId }) {
        const url = `${this.url}/api/schools/${schoolId}/reports/active-users`;
        const expectedResponses = [200, 403];
        const response = await this.requestMaker.makeRequest(url, {
            method: 'POST',
            body: JSON.stringify({
                from,
                to
            })
        }, expectedResponses);
        if (response.status === 403) {
            const body = response.json;
            if (body.reason === school_analytics_service_consts_1.errorCodes.SCHOOL_NOT_FOUND) {
                throw new SchoolNotFoundError_1.default();
            }
            if (body.reason === school_analytics_service_consts_1.errorCodes.SCHOOL_SYNC_EXPIRED) {
                throw new SchoolSyncExpiredError_1.default();
            }
        }
        return response.json;
    }
    /**
     * @deprecated newer `fetchActiveUsersBySchool` should be used instead of this method
     */
    async fetchActiveUsers({ from, to }) {
        const url = `${this.url}/api/reports/active-users`;
        const expectedResponses = [200, 403];
        const response = await this.requestMaker.makeRequest(url, {
            method: 'POST',
            body: JSON.stringify({
                from,
                to
            })
        }, expectedResponses);
        if (response.status === 403) {
            const body = response.json;
            if (body.reason === school_analytics_service_consts_1.errorCodes.SCHOOL_NOT_FOUND) {
                throw new SchoolNotFoundError_1.default();
            }
            if (body.reason === school_analytics_service_consts_1.errorCodes.SCHOOL_SYNC_EXPIRED) {
                throw new SchoolSyncExpiredError_1.default();
            }
        }
        return response.json;
    }
}
exports.default = SchoolAnalyticsServiceClient;
//# sourceMappingURL=SchoolAnalyticsServiceClient.js.map